export default {
	title: "Meeting Assistant",
	addMeetingLinkButton: "Add meeting link",
	notNowButton: "Not now",
	doNotShowLabel: "Do not show this again.",
	bodyContent: [
		"<p>Teaming’s Meeting Assistant takes meeting notes for you so that you can stay engaged and connected with your co-workers during meetings.</p>",
		"<p>Add your Zoom, Google Meet, or Microsoft Teams videoconference link to a note, then send Meeting Assistant to your meeting to record, transcribe, and summarize notes for you. (Don’t worry, we don’t keep your recordings.)</p>",
	].join( "" ),
};
